module.exports = __webpack_public_path__ + "static/media/tart.b7221525.jpg";